import { Platform } from "react-native";
import React from "react";

export const walletImport = {};
